import { render, staticRenderFns } from "./dictionary.vue?vue&type=template&id=5c73c3e7&scoped=true"
import script from "./dictionary?vue&type=script&lang=js&external"
export * from "./dictionary?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c73c3e7",
  null
  
)

export default component.exports